import React, { useState } from 'react';
import { Button, Stack, Typography, Tooltip, Badge } from '@mui/material';
import {
  Toolbar,
  ToolbarButton,
  ColumnsPanelTrigger,
  FilterPanelTrigger,
} from '@mui/x-data-grid';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import SystemUpdateAltIcon from '@mui/icons-material/SystemUpdateAlt';
import SettingsIcon from '@mui/icons-material/Settings';
import ViewColumnIcon from '@mui/icons-material/ViewColumn';
import FilterListIcon from '@mui/icons-material/FilterList';
import { useNavigate } from 'react-router';
import DeviceConfigsModal from './DeviceConfigsModal';

function NodeGridToolbar({ region, service, type, deployConfigToSelected }) {
  const navigate = useNavigate();

  const [deviceConfigsOpen, setDeviceConfigsOpen] = useState(false);
  const disabled = region.storage.instances.length === 0;

  return (
    <Toolbar
      sx={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}
    >
      <Stack direction='row' spacing={1}>
        <Tooltip
          title={Boolean(disabled) ? 'Storage node required for region' : ''}
        >
          <span>
            {' '}
            <Button
              color='brand'
              variant='outlined'
              disabled={Boolean(disabled)}
              onClick={() =>
                navigate({
                  pathname: `/resources/provider/${region.provider_uuid}/region/${region.region_uuid}/node/new`,
                  search: `?service=${service}&type=${type}`,
                })
              }
            >
              <Stack direction='row' spacing={1} alignItems='center'>
                <AddCircleOutlineIcon />
                <Typography variant='button' display='block' gutterBottom>
                  Add
                </Typography>
              </Stack>
            </Button>
            <Button variant='outlined' onClick={deployConfigToSelected}>
              <Stack direction='row' spacing={1} alignItems='center'>
                <SystemUpdateAltIcon />
                <Typography variant='button' display='block' gutterBottom>
                  Deploy Config
                </Typography>
              </Stack>
            </Button>
            <Button
              variant='outlined'
              disabled={Boolean(disabled)}
              onClick={() => setDeviceConfigsOpen(true)}
            >
              <Stack direction='row' spacing={1} alignItems='center'>
                <SettingsIcon />
                <Typography variant='button' display='block' gutterBottom>
                  Manage Device Configs
                </Typography>
              </Stack>
            </Button>
          </span>
        </Tooltip>
      </Stack>
      <Stack direction='row' spacing={1}>
        <Tooltip title='Columns'>
          <ColumnsPanelTrigger render={<ToolbarButton />}>
            <ViewColumnIcon fontSize='small' color='brandBlack' />
          </ColumnsPanelTrigger>
        </Tooltip>
        <Tooltip title='Filters'>
          <FilterPanelTrigger
            render={(props, state) => (
              <ToolbarButton {...props}>
                <Badge badgeContent={state.filterCount} variant='dot'>
                  <FilterListIcon fontSize='small' color='brandBlack' />
                </Badge>
              </ToolbarButton>
            )}
          />
        </Tooltip>
      </Stack>
      <DeviceConfigsModal
        open={deviceConfigsOpen}
        region={region}
        handleClose={() => {
          setDeviceConfigsOpen(false);
        }}
      />
    </Toolbar>
  );
}
export default NodeGridToolbar;
